module.exports = ".block_groups_charconfig{\n  border: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/conversation/live-chat/live-chat.component.css
// module id = ./src/app/pages/admin/icontact/setting/conversation/live-chat/live-chat.component.css
// module chunks = main